// extracted by mini-css-extract-plugin
module.exports = {"anchorBtn":"AreaControl_anchorBtn__39HM2","selected":"AreaControl_selected__VnliK"};